const DEFAULT_REMOTE_API = 'https://tapp-bjyu.onrender.com';
const DEFAULT_LOCAL_API = 'http://localhost:3001';
const DEV_HOSTNAMES = new Set(['localhost', '127.0.0.1']);

const isLocalHost = (hostname = '') => {
  if (!hostname) return false;
  if (DEV_HOSTNAMES.has(hostname)) {
    return true;
  }
  return hostname.endsWith('.local');
};

const resolveApiBase = () => {
  if (typeof window !== 'undefined' && isLocalHost(window.location.hostname)) {
    return process.env.REACT_APP_LOCAL_API_BASE || DEFAULT_LOCAL_API;
  }

  if (process.env.REACT_APP_API_BASE) {
    return process.env.REACT_APP_API_BASE;
  }

  if (typeof window !== 'undefined') {
    if (window.location.hostname.endsWith('.vercel.app')) {
      return DEFAULT_REMOTE_API;
    }
  }

  if (process.env.NODE_ENV === 'production') {
    return DEFAULT_REMOTE_API;
  }

  return DEFAULT_LOCAL_API;
};

const API_BASE = resolveApiBase();

export const getApiBase = () => API_BASE;
export const apiUrl = (path = '') => `${API_BASE}${path}`;
